import { render } from "./ImageRenderer.vue?vue&type=template&id=ee196f5c&scoped=true"
import script from "./ImageRenderer.vue?vue&type=script&lang=js"
export * from "./ImageRenderer.vue?vue&type=script&lang=js"

import "./ImageRenderer.vue?vue&type=style&index=0&id=ee196f5c&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee196f5c"]])

export default __exports__